import { render, staticRenderFns } from "./configuration-assays-grid.vue?vue&type=template&id=6b2e912c&scoped=true&"
import script from "./configuration-assays-grid.ts?vue&type=script&lang=ts&"
export * from "./configuration-assays-grid.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-assays-grid.scss?vue&type=style&index=0&id=6b2e912c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2e912c",
  null
  
)

export default component.exports